import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Flex, Spin } from "antd";
const Spinner = ({ color, size = "small" }) => (
  <Flex align="center" gap="middle">
    <Spin
      size={size}
      indicator={
        <LoadingOutlined
          style={{
            color: `${color || "black"}`,
          }}
          spin
        />
      }
    />
  </Flex>
);
export default Spinner;
